import type * as Core from "@zeller-public/payments-sdk-core";

import { onRequestQueryEnd } from "../on-request-query-end";
import { logger } from "../shared/logger";
import { $postMessage } from "./post-message";

////////////////////////////////////////////////////////////////////////////////

export function postResponse(
	response: Exclude<Core.Protocol.Response, string>,
): void {
	logger.debug("post response: send", {
		$type: response.$type,
		value:
			response.$type === "Result" || response.$type === "ResultError"
				? response.value
				: response,
	});

	if (response.$type === "Result" || response.$type === "ResultError") {
		onRequestQueryEnd();
	}

	$postMessage(JSON.stringify(response));
}
